import {
  Agent,
  AgentCallRequest,
  AgentCallResponse,
  AgentContinueRequest,
  AgentRequest,
  AgentResponse,
  parseAgentResponse,
} from "@/types/app/agent";
import { AxiosPromise, AxiosResponse } from "axios";
import { ApiService } from "./api.service";

export const upsertAgent = async (request: AgentRequest): AxiosPromise<Agent> => {
  const response: AxiosResponse<AgentResponse> = await ApiService.post(`/v5/agents`, request);
  return { ...response, data: parseAgentResponse(response.data) };
};

// No proxy to avoid timeout for long-running agents
export const callAgent = async (request: AgentCallRequest): AxiosPromise<AgentCallResponse> => {
  const response: AxiosResponse<AgentCallResponse> = await ApiService.post(`/v5/agents/call`, request, {}, true);
  return response;
};

// No proxy to avoid timeout for long-running agents
export const continueAgent = async (request: AgentContinueRequest): AxiosPromise<AgentCallResponse> => {
  const response: AxiosResponse<AgentCallResponse> = await ApiService.post(`/v5/agents/continue`, request, {}, true);
  return response;
};
